/** Compiled, same-origin routes. Publishing metadata never supplies executable URLs or layouts. */
export type NativePageRoute = {
  pageId: string;
  path: string;
  legacyDetail?: { parameter: string; segment: string };
};

export const nativePageRoutes: ReadonlyArray<NativePageRoute> = [
  { pageId: 'inspiration-blog-performance', path: '/commercial-ops/inspiration-blog-performance' },
  { pageId: 'email-clicks-by-day', path: '/commercial-ops/email-clicks-by-day' },
  { pageId: 'lpc-post-campaign', path: '/commercial-ops/lpc-post-campaign' },
  { pageId: 'flash-supply-forecasts', path: '/commercial-ops/flash-supply-forecasts' },
  { pageId: 'room-inventory-availability', path: '/commercial-ops/room-inventory-availability' },

  { pageId: 'flash-funnel', path: '/commercial-ops/flash-funnel' },
  { pageId: 'contribution-margin', path: '/commercial-ops/contribution-margin' },
  { pageId: 'performance-marketing', path: '/commercial-ops/performance-marketing' },

  { pageId: 'commercial-kpi-tracker', path: '/commercial-ops/commercial-kpi-tracker' },
  { pageId: 'countries', path: '/commercial-ops/countries' },
  { pageId: 'customer-comms', path: '/commercial-ops/customer-comms' },
  { pageId: 'flash-post-campaign', path: '/commercial-ops/flash-post-campaign' },
  { pageId: 'luxplus', path: '/commercial-ops/luxplus' },

  { pageId: 'lpc-offer-health', path: '/commercial-ops/lpc-offer-health' },
  { pageId: 'product-performance', path: '/commercial-ops/product-performance' },
  { pageId: 'hotel-deal-performance', path: '/commercial-ops/hotel-deal-performance' },
  { pageId: 'experience-dash', path: '/commercial-ops/experience-dash' },
  { pageId: 'accommodation-views-impressions-sales', path: '/commercial-ops/accommodation-views-impressions-sales' },
  { pageId: 'marketplace-monitoring', path: '/commercial-ops/marketplace-monitoring' },
  { pageId: 'product-dash', path: '/commercial-ops/product-dash' },
  { pageId: 'rm-monitor', path: '/commercial-ops/rm-monitor' },
  { pageId: 'qr-campaigns', path: '/commercial-ops/qr-campaigns' },
  { pageId: 'ltlp-manifest', path: '/commercial-ops/ltlp-manifest' },
  { pageId: 'lebt-commercial', path: '/commercial-ops/lebt-commercial' },
  { pageId: 'cs-conversations', path: '/commercial-ops/cs-conversations' },
  { pageId: 'agent-hub-bdm', path: '/commercial-ops/agent-hub-bdm' },
  { pageId: 'agent-hub', path: '/commercial-ops/agent-hub' },
  { pageId: 'daily-snapshot', path: '/commercial-ops/daily-snapshot' },
  { pageId: 'daily-board', path: '/commercial-ops/daily-board' },
  { pageId: 'loyalty-societe', path: '/commercial-ops/loyalty-societe' },
  {
    pageId: 'tours-command-centre',
    path: '/tours/command-centre',
    legacyDetail: { parameter: 'nativeTour', segment: 'tour' },
  },
];

/** Remove only workspace routing state; dates, filters and app-owned parameters survive unchanged. */
export function nativePageParams(search: string): URLSearchParams {
  const params = new URLSearchParams(search);
  for (const key of [
    'view',
    'lens',
    'thread',
    'card',
    'library',
    'export',
    'dataset',
    'domain',
    'metric',
    'section',
    'create',
    'createSpace', // Retired workspace hint: strip it instead of forwarding it as an app filter.
    'brief',
    'lensView',
    'nativeTour',
  ]) {
    params.delete(key);
  }
  return params;
}

/** Reopening an app's own top tab must not reset its data mode or filters. */
export function nativePageNavigationUrl(href: string, pathname: string, search: string, hash = ''): string {
  const route = nativePageRoutes.find(
    (page) => page.path === href && (pathname === page.path || pathname.startsWith(`${page.path}/`)),
  );
  if (!route) return href;
  const query = nativePageParams(search).toString();
  return `${href}${query ? `?${query}` : ''}${hash}`;
}
